// Request schemas
export {
  AppointmentCreatedBy,
  BookedAppointmentsConsistency,
  BookedAppointmentsReadPurpose,
  bookedAppointmentsConsistencySchema,
  bookedAppointmentsReadMetadataSchema,
  type BookedAppointmentsReadMetadata,
  InitialBookingReasonSource,
  IntakeType,
  voiceCallOutcomeSchema,
  createPatientRequestSchema,
  schedulingPatientIdentitySchema,
  createPatientFromIntakeRequestSchema,
  intakeCoverageSchema,
  searchOpenAppointmentsRequestSchema,
  searchPatientsRequestSchema,
  bookAppointmentRequestSchema,
  cancelAppointmentRequestSchema,
  getBookedAppointmentsRequestSchema,
  rescheduleAppointmentRequestSchema,
  rescheduleAppointmentUnitRequestSchema,
  getCurrentAppointmentActionId,
  getAllAppointmentTypesRequestSchema,
  getTopInsurancePackagesRequestSchema,
  createPatientInsuranceRequestSchema,
  getLatestReferralRequestSchema,
  appointmentStatusSchema,
  availabilityAppointmentTypeSchema,
  getAvailabilityRequestSchema,
  getSchedulingOptionsRequestSchema,
  getLocationsRequestSchema,
  checkEligibilityRequestSchema,
  relevantSchedulingRulesRequestSchema,
  relevantSchedulingRulesResponseSchema,
  createTelephoneEncounterRequestSchema,
  createTelephoneEncounterResponseSchema,
  createPatientCaseRequestSchema,
  getPatientMedicationsRequestSchema,
  ingestTranscriptPayloadSchema,
  stallMetricEntrySchema,
  voiceLlmModelSchema,
  voiceModelConfigurationSchema,
  experimentAssignmentSchema,
  experimentTagSchema,
  toolErrorTypeSchema,
  toolCallErrorSchema,
  sessionReportSchema,
  dateFormatSchema,
  getProviderNamesResponseSchema,
  getClinicFaqResponseSchema,
  getOfficeDirectoryRequestSchema,
  getOfficeDirectoryResponseSchema,
  getPatientNamesByPhoneRequestSchema,
  getPatientNamesByPhoneResponseSchema,
  submitVoiceCsatPayloadSchema,
} from "@/shared/agent-api/requests";
export { appointmentSlotToolSchema as bookAppointmentSlotSchema } from "@/shared/agent-api/scheduling-tool-schemas";
export {
  appointmentActionIdSchema,
  normalizedEhrIdSchema,
  versionedAppointmentActionIdSchema,
  versionedAppointmentSlotActionIdSchema,
} from "@/shared/common-schemas";
export {
  ChatItemRole,
  ChatItemType,
  conversationItemAddedEventSchema,
  EventType,
  functionToolsExecutedEventSchema,
  rawSessionChatItemSchema,
  sessionEventSchema,
  sessionEventsSchema,
  speechCreatedEventSchema,
} from "@/shared/agent-api/session-events";
export type { RawSessionChatItem, SessionEvent } from "@/shared/agent-api/session-events";

export type {
  SearchOpenAppointmentsRequest,
  SearchPatientsRequest,
  BookAppointmentSlot,
  BookAppointmentRequest,
  CancelAppointmentRequest,
  CreatePatientFromIntakeRequest,
  GetBookedAppointmentsRequest,
  AvailabilityAppointmentType,
  ScheduleAvailability,
  GetAvailabilityRequest,
  GetSchedulingOptionsRequest,
  GetLocationsRequest,
  IntakeCoverage,
  RescheduleAppointmentRequest,
  RescheduleAppointmentUnitRequest,
  CheckEligibilityRequest,
  RelevantSchedulingRulesRequest,
  RelevantSchedulingRulesResponse,
  CreateTelephoneEncounterRequest,
  CreateTelephoneEncounterResponse,
  CreatePatientCaseRequest,
  GetPatientMedicationsRequest,
  IngestTranscriptPayload,
  StallMetricEntry,
  VoiceLlmModel,
  VoiceModelConfiguration,
  ExperimentAssignment,
  ExperimentTag,
  ToolErrorType,
  ToolCallError,
  VoiceCallOutcome,
  SessionReport,
  GetProviderNamesResponse,
  GetClinicFaqResponse,
  GetOfficeDirectoryRequest,
  GetOfficeDirectoryResponse,
  OfficeDirectoryOffice,
  OfficeDirectoryProvider,
  GetPatientNamesByPhoneRequest,
  GetPatientNamesByPhoneResponse,
  SubmitVoiceCsatPayload,
  SchedulingPatientIdentity,
} from "@/shared/agent-api/requests";

export {
  AppointmentSlotPreferenceTier,
  availabilityAppointmentSlotResponseSchema,
  appointmentSlotPreferenceTierSchema,
  checkEligibilityResponseSchema,
  bookAppointmentResponseSchema,
  cancelAppointmentResponseSchema,
  createPatientFromIntakeResponseSchema,
  eligibilityProviderResultSchema,
  getBookedAppointmentsResponseSchema,
  getLocationsResponseSchema,
  getSchedulingOptionsResponseSchema,
  ingestTranscriptResponseSchema,
  rescheduleAppointmentResponseSchema,
  rescheduleAppointmentUnitResponseSchema,
  rescheduleAvailabilityOptionResponseSchema,
  scheduleAvailabilityOptionResponseSchema,
  submitVoiceCsatResponseSchema,
  schedulingDecisionSchema,
  SchedulingModality,
  CareMode,
  SchedulingOptionIneligibilityReason,
  SchedulingOptionStatus,
  schedulingOptionSchema,
  SchedulingRequiredInput,
  SchedulingVisitCategory,
} from "@/shared/agent-api/responses";
export {
  getLivekitApiOperation,
  isLivekitTracedHttpRoute,
  LIVEKIT_API_OPERATION_ATTRIBUTE,
  LIVEKIT_API_OPERATIONS,
  LIVEKIT_ENDPOINT_ROOT_SPAN_NAME,
  LIVEKIT_ENDPOINT_SPAN_ID_ATTRIBUTE,
  LIVEKIT_ENDPOINT_TRACE_ID_ATTRIBUTE,
  LIVEKIT_SESSION_MARKER_SPAN_NAME,
  LIVEKIT_SESSION_SPAN_ID_ATTRIBUTE,
  LIVEKIT_SESSION_TRACE_ID_ATTRIBUTE,
  LIVEKIT_TRACE_STATE_KEY,
  LIVEKIT_TRACE_STATE_VALUE,
  LIVEKIT_TRACED_HTTP_ROUTES,
  type LivekitApiOperation,
  type LivekitTracedHttpRoute,
  type LivekitVoiceApiPath,
} from "@/shared/agent-api/trace-routes";
export {
  AgentResponseKind,
  RESPONSE_LATENCY_ATTRIBUTE,
  RESPONSE_LATENCY_SPAN_NAME,
  ResponseClassificationSource,
  VoiceAgentRuntime,
  responseLatencySpanAttributesSchema,
} from "@/shared/agent-api/response-latency";
export type { ResponseLatencySpanAttributes } from "@/shared/agent-api/response-latency";

export {
  agentCoverageSchema,
  agentPatientSchema,
  createPatientCaseResponseSchema,
  flattenMedicationRecognitionTerms,
  getPatientMedicationsResponseSchema,
  patientNotFoundResponseSchema,
  patientMedicationSchema,
  PatientIntakeStatus,
  PatientMatchMethod,
  RecommendationType,
  searchPatientsResponseSchema,
} from "@/shared/agent-api/responses";

export type {
  SearchPatientsResponse,
  SearchOpenAppointmentsResponse,
  BookAppointmentResponse,
  CancelAppointmentResponse,
  BookedAppointment,
  CreatePatientFromIntakeResponse,
  GetBookedAppointmentsResponse,
  AvailabilityResponse,
  GetSchedulingOptionsResponse,
  GetLocationsResponse,
  Location as AgentLocation,
  AvailabilityAppointmentSlot,
  RescheduleAvailabilityOption,
  ScheduleAvailabilityOption,
  Coverage,
  RescheduleAppointmentResponse,
  RescheduleAppointmentUnitResponse,
  SchedulingDecision,
  SchedulingOption,
  EligibilityProviderResult,
  EligibilityLocationResult,
  AgenticEligibilityResponse,
  RankedAppointment,
  RankingNoRecommendationsReason,
  AgenticRankedAppointmentsResponse,
  CheckEligibilityResponse,
  CreatePatientCaseResponse,
  GetPatientMedicationsResponse,
  PatientMedication,
} from "@/shared/agent-api/responses";
export { PatientCaseDeliveryStatus, PatientCaseType } from "@/shared/models/patient-case";
export { PatientSchedulingInsuranceStatus, SelfPayFollowupStatus } from "@/shared/models/scheduling-self-pay";

export {
  schedulingBookAppointmentToolSchema,
  schedulingBookedAppointmentsDateRangeToolSchema,
  schedulingConfirmAppointmentToolSchema,
  schedulingRetrievePatientDemographicsToolSchema,
  schedulingOpenAppointmentLookupToolParamsSchema,
  schedulingOpenAppointmentLookupWindowToolSchema,
  schedulingPatientLookupToolSchema,
  schedulingRescheduleAppointmentToolSchema,
  schedulingRescheduleBySlotIdsToolSchema,
} from "@/shared/agent-api/scheduling-tool-schemas";
